import { render } from "./PaymentReceiptCreateApplicationSection.vue?vue&type=template&id=90218e02&scoped=true"
import script from "./PaymentReceiptCreateApplicationSection.vue?vue&type=script&lang=js"
export * from "./PaymentReceiptCreateApplicationSection.vue?vue&type=script&lang=js"

import "./PaymentReceiptCreateApplicationSection.vue?vue&type=style&index=0&id=90218e02&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90218e02"]])

export default __exports__